<template>
  <div class="w-fit mx-auto mt-10 flex space-x-2">
    <div class="h-0.5 w-2 bg-gray-600" />

    <div class="h-0.5 w-32 bg-gray-600" />

    <div class="h-0.5 w-2 bg-gray-600" />
  </div>
</template>
